import { render, staticRenderFns } from "./postDynamic.vue?vue&type=template&id=31f9d320&scoped=true"
import script from "./postDynamic.vue?vue&type=script&lang=js"
export * from "./postDynamic.vue?vue&type=script&lang=js"
import style0 from "./postDynamic.vue?vue&type=style&index=0&id=31f9d320&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f9d320",
  null
  
)

export default component.exports